import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { FaCrown, FaArrowRight, FaRupeeSign, FaClock } from 'react-icons/fa'

const MemberShipPlan = () => {
  const [formData, setFormData] = useState({
    amount: '',
    timePeriod: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log('Form submitted:', formData)
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 md:p-8">
      <div className="max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl shadow-2xl p-6 sm:p-8 border border-gray-200"
        >
          <motion.div
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            className="flex flex-col sm:flex-row items-center gap-4 mb-8 sm:mb-12"
          >
            <div className="bg-blue-100 p-5 rounded-2xl shadow-md border border-blue-200">
              <FaCrown className="text-blue-600 w-8 h-8" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-800">
                Membership Plan
              </h1>
              <p className="text-gray-500 mt-2 text-base sm:text-lg">Create premium access package</p>
            </div>
          </motion.div>

          <form onSubmit={handleSubmit} className="space-y-8">
            <motion.div
              whileHover={{ scale: 1.02 }}
              className="group"
            >
              <label className="block text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <FaRupeeSign className="text-blue-500" />
                Amount (₹)
              </label>
              <div className="relative">
                <input
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  placeholder="299"
                  className="w-full px-6 py-4 rounded-2xl border border-gray-300 focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all duration-300 text-lg bg-white text-gray-800"
                />
                <span className="absolute right-6 top-1/2 -translate-y-1/2 text-gray-400 font-medium">
                  INR
                </span>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.02 }}
              className="group"
            >
              <label className="block text-base font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <FaClock className="text-blue-500" />
                Time Period (In Days)
              </label>
              <input
                type="number"
                name="timePeriod"
                value={formData.timePeriod}
                onChange={handleChange}
                placeholder="30"
                className="w-full px-6 py-4 rounded-2xl border border-gray-300 focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all duration-300 text-lg bg-white text-gray-800"
              />
            </motion.div>

            <motion.button
              whileHover={{ scale: 1.02, translateY: -2 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              className="w-full mt-6 sm:mt-10 px-6 sm:px-8 py-4 sm:py-5 bg-blue-600 text-white rounded-xl sm:rounded-2xl font-semibold text-base sm:text-lg shadow-lg sm:shadow-xl hover:bg-blue-700 transition-all duration-300 flex items-center justify-center gap-2 sm:gap-3 group"
            >
              <span>Create Premium Plan</span>
              <FaArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
            </motion.button>
          </form>
        </motion.div>
      </div>
    </div>
  )
}

export default MemberShipPlan
